import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PriceCodeRule } from '../../../../models/scan-testing.model';

// Configures a Price Code rule: pick from price codes seen on the loaded
// barcodes, or enter one manually. Each code seeds an extended test row.
@Component({
  selector: 'app-sr-price-code-modal',
  templateUrl: './sr-price-code-modal.component.html',
  standalone: false,
  styleUrls: ['./sr-modal-shared.scss']
})
export class SrPriceCodeModalComponent implements OnInit {
  @Input() initial?: PriceCodeRule;
  @Input() priceCodes: string[] = [];
  @Output() confirmed = new EventEmitter<PriceCodeRule>();
  @Output() cancelled = new EventEmitter<void>();

  searchText = '';
  manualEntry = '';
  selectedCodes = new Set<string>();

  ngOnInit(): void {
    this.selectedCodes = new Set(this.initial?.priceCodes ?? []);
  }

  filteredOptions(): string[] {
    const q = this.searchText.trim().toLowerCase();
    if (!q) { return this.priceCodes; }
    return this.priceCodes.filter((c) => c.toLowerCase().includes(q));
  }

  isSelected(code: string): boolean { return this.selectedCodes.has(code); }

  toggleCode(code: string): void {
    if (this.selectedCodes.has(code)) { this.selectedCodes.delete(code); }
    else { this.selectedCodes.add(code); }
  }

  addManual(): void {
    const code = this.manualEntry.trim().toUpperCase();
    if (code) { this.selectedCodes.add(code); }
    this.manualEntry = '';
  }

  removeCode(code: string): void {
    this.selectedCodes.delete(code);
  }

  selectedList(): string[] {
    return Array.from(this.selectedCodes);
  }

  private newSeedKey(): string {
    return `pc_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  }

  onConfirm(): void {
    this.confirmed.emit({
      type: 'price_code',
      priceCodes: Array.from(this.selectedCodes),
      seedKey: this.initial?.seedKey || this.newSeedKey()
    });
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  trackCode(_idx: number, code: string): string { return code; }
}
